export function getUserAgent() {
    return "infoplaza-network|buienalarm-web";
}